export default __webpack_public_path__ + "static/media/about-1.6fc20e08.svg";